<template>
<div style="margin-bottom: 100px">

    <vue-headful title="Places" />

    <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-3': true}">
        <v-row no-gutters>
            <!-- type filter-->
            <v-col cols="12" md="3" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Type</div>
                    <v-select class="im-select pa-0 ma-0" flat solo v-model="type" :items="config.place_types" item-text="name" item-value="code" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" @input="filterItems()"
                        hide-details></v-select>
                </v-card>
            </v-col>
            <!--./ type filter-->

        </v-row>

        <!-- SEARCH -->
        <div class="im-search mt-3 mb-1">
            <div class="d-flex">
                <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable placeholder="Type here to search by field ..." append-icon="search" hide-details></v-text-field>
                <v-icon medium v-if="$vuetify.breakpoint.smAndDown" class="px-1" @click="dialog_mobile_sort = true">swap_vert
                </v-icon>
                </v-icon>
            </div>
            <div class="d-flex mx-1 py-2 fields align-center">
                <span class="detail mr-1 hidden-sm-and-down">Find in:</span>
                <v-btn v-for="field in search_fields" :key="field.value" small rounded depressed class="detail mx-1" :color="field.selected ? 'primary' : 'grey lighten-2'" :text-color="field.selected ? 'white' : 'grey'" @click="selectField(field)">
                    <span class="text-capitalize">{{field.text}}</span>
                </v-btn>
            </div>
        </div>
        <!-- ./ SEARCH -->

        <!--data table-->
        <v-card tile flat class="mx-1">
            <im-table-header :items="im_header" @clickSort="sortField($event)" />
        </v-card>
        <!--./ data table -->
        <div class="mx-1" style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>

        <!-- DATATABLE ROWS -->
        <v-card tile flat style="background-color: transparent !important;" class="mx-1">

            <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                <template v-slot:default="props">
                    <template v-for="item in props.items">
                        <im-place-item :item="item" @click.native="openEdit(item)" />
                    </template>
                </template>
                <template v-slot:no-data>
                    <v-alert :value="true" type="info" color="primary">
                        No data available.
                    </v-alert>
                </template>
            </v-data-iterator>
        </v-card>
    </v-container>

    <!-- add place button -->
    <v-btn color="primary elevation-16" large fab dark fixed bottom right @click="openCreate()">
        <v-icon>add</v-icon>
    </v-btn>
    <!-- ./ add place button -->

    <!-- add/edit place dialog-->
    <im-place-modal :dialog="place_dialog" :id="item_id" @exit="place_dialog = false, item_id= null" @refresh="getItems()" />

    <!-- dialog mobile sort -->
    <v-dialog v-model="dialog_mobile_sort" max-width="300px">
        <v-card>
            <v-card-text class="important">
                Sort Items by
            </v-card-text>
            <im-sort-filed :items="im_header" @clickSort="sortField($event)"></im-sort-filed>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog_mobile_sort = false">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog dialog mobile sort -->

</div>
</template>

<script>
import {
    mapActions
} from 'vuex'
import defaults from "../components/utils/PropDefaults.js";
import IMTableHeader from '../components/utils/IMTableHeader.vue';
import IMSortField from "../components/utils/IMSortField.vue";
import IMPlaceItem from '../components/items/PlaceCard.vue';
import IMPlaceHierarchy from '../components/utils/IMPlaceHierarchy.vue';
import IMPlaceSearch from '../components/utils/IMPlaceSearch.vue';
import IMPlaceModal from "../components/items/PlaceModal.vue"

export default {
    components: {
        "im-table-header": IMTableHeader,
        "im-sort-filed": IMSortField,
        "im-place-item": IMPlaceItem,
        "im-place-hierarchy": IMPlaceHierarchy,
        "im-place-search": IMPlaceSearch,
        "im-place-modal": IMPlaceModal,
    },

    data() {
        return {
            place_dialog: false,
            item_id: null,

            place: this.$clone(defaults.place_item),

            config: {
                place_types: [],
            },

            search_fields: [
                {
                    text: 'Id',
                    value: 'id',
                    selected: true
                }, {
                    text: 'Name',
                    value: 'name_real',
                    selected: true
                }, {
                    text: 'Search text',
                    value: 'search_text',
                    selected: true
            }],
            //filter
            type: null,

            // search
            search: null,
            search_timeout: 500,

            sort_field_item: 'hits',
            sort_field_dir: 'desc',

            // modals
            add_dialog: false,
            delete_dialog: false,
            dialog_mobile_sort: false,

            // places table
            im_header: [
                {
                    text: "Id",
                    sortable: false,
                    sort_dir: null,
                    align: "left",
                    width: "13%"
                }, {
                    text: "Country",
                    sortable: true,
                    sort_dir: null,
                    sort_order: "country",
                    align: "left",
                    width: "12%"
                }, {
                    text: "Name",
                    sortable: true,
                    sort_dir: null,
                    sort_order: "name_real",
                    align: "left",
                    width: "25%"
                }, {
                    text: "Region",
                    sortable: true,
                    sort_dir: null,
                    sort_order: "region_real",
                    align: "left",
                    width: "25%"
                }, {
                    text: "Priority",
                    sortable: true,
                    sort_dir: null,
                    sort_order: 'priority',
                    align: "left",
                    width: "13%"
                }, {
                    text: "Hits",
                    sortable: true,
                    sort_dir: 'desc',
                    sort_order: 'hits',
                    align: "left",
                    width: "10%"
            }],
            loading: true,
            total: 0,
            page: 1,
            size: 10,
            itemsPerPageOptions: [10, 25, 50, 100],

            //props
            items: [],

            errors: []
        }
    },

    created: function () {
        this.getItems();
        this.getConfig();
    },

    watch: {
        page: {
            handler() {
                this.getItems();
            }
        },
        size: {
            handler() {
                this.getItems();
            }
        },

        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems, 500);
            }
        }
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),


        getConfig() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/places/config";

            this.$axios.get(endpoint)
                .then(response => {
                    this.config = response.data;
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getItems() {
            // we are currently loading
            this.loading = true;

            // prepare search string
            let search = this.search;
            if(search === "" || search === undefined) {
                search = null;
            }

            //prepare sorting & direction params
            let orders = [];
            let dirs = [];
            if(this.sort_field_item) {
                dirs.push(this.sort_field_dir);
                orders.push(this.sort_field_item);
            }

            // prepare type search filter
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query params
            let params = {
                params: {
                    search: search,
                    fields: fields,
                    type: this.type,
                    size: this.size,
                    page: this.page,
                    order: orders,
                    dir: dirs,
                    stamp: stamp,
                }
            };

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/places/places";

            this.$axios.get(endpoint, params)
                .then(response => {
                    // if the current stamp matches the received stamp, populate items
                    if(parseInt(this.current_stamp) === parseInt(response.data.meta.stamp)) {
                        this.items = response.data.data;
                        this.total = response.data.pagination.total;
                    }
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        openCreate() {
            this.item_id = null;
            this.place_dialog = true;
        },

        openEdit(current_item) {
            this.item_id = current_item.id;
            this.place_dialog = true;
        },

        openDeleteModal(item) {
            this.delete_place_id = item.id;
            this.delete_dialog = true;
        },

        destroy() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/places/places";

            // call delete endpoint
            this.$axios.delete(endpoint + "/" + this.delete_place_id)
                .then(response => {
                    this.success("Place was deleted.");
                    this.add_dialog = false;
                    this.delete_dialog = false;
                    this.$router.push({
                        path: "/"
                    });
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.error(error);
                })
                .finally(() => {});
        },

        selectField(field) {
            field.selected = !field.selected;
            if(this.search) {
                this.getItems();
            }
        },

        sortField(sortItem) {
            this.page = 1;
            this.sort_field_item = sortItem.sort_order;
            this.sort_field_dir = sortItem.sort_dir;
            this.getItems();
            this.dialog_mobile_sort = false;
        },

        filterItems() {
            this.page = 1;
            this.getItems();
        }
    }
};
</script>

<style scoped>
.error-rules {
    border-bottom: 1px solid red;
}
</style>
